<gea-asset-table
  [assetTable]="table"
  [showMotorStatus]="true"
></gea-asset-table>
